import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import { AppSEO, NotFound } from "@hl/shared-features/lib/features/layout";
import CollectionActivity from "@hl/shared-features/lib/features/marketplace/activity/CollectionActivity";
import { AppShell, Box, createStyles, Tabs } from "@mantine/core";
import { useParams } from "react-router-dom";

import { useMintPage } from "~hooks/useMintPage";
import { MintContext } from "~hooks/useMintState";

import { AppHeader } from "../layout/Header";

import MarketplaceHeader from "./MarketplaceHeader";
import { MarketplaceTokens } from "./MarketplaceTokens";
import { useMarketplaceBrowseCollectionQuery } from "./queries/browse.graphql.generated";

const useStyles = createStyles((theme) => ({
  link: {
    textDecoration: "none",
  },
  appShellMain: {
    paddingLeft: "20px !important",
    paddingRight: "20px !important",
    [theme.fn.largerThan(theme.breakpoints.md)]: {
      paddingLeft: "40px !important",
      paddingRight: "40px !important",
    },
  },
}));

const MarketplacePage = () => {
  const { collectionId } = useParams();

  const { data, loading } = useMarketplaceBrowseCollectionQuery({
    variables: {
      collectionId: collectionId!,
      // metadata hidden automatically returns only minted attributes
      minted: null,
    },
    fetchPolicy: "cache-first",
    skip: !collectionId,
  });

  const browseCollection = data?.getPublicCollection;

  const mintPage = useMintPage(collectionId ?? "", { skipAuction: true });
  const {
    collectionLoading,
    collection,
    isSeriesMint,
    isCodeGenMint,
    chainId,
    address,
    // disabledCardText,
  } = mintPage;

  const { classes } = useStyles();

  if (!collectionId) {
    return <NotFound />;
  }

  if ((!browseCollection && loading) || collectionLoading) {
    return <LoadingPage />;
  }

  if (!browseCollection || !collection || !(isSeriesMint || isCodeGenMint)) {
    return <NotFound />;
  }

  return (
    <MintContext.Provider value={mintPage}>
      <AppSEO
        title={`${browseCollection.name} - Marketplace`}
        description={`Marketplace of ${browseCollection.name} tokens`}
      />
      <AppShell
        classNames={{
          main: classes.appShellMain,
        }}
        header={<AppHeader />}
      >
        <Box>
          <MarketplaceHeader mb={40} />
          <Tabs defaultValue="artwork" keepMounted={false}>
            <Tabs.List mb="xl">
              <Tabs.Tab value="artwork">Artwork</Tabs.Tab>
              <Tabs.Tab value="activity">Activity</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="artwork">
              <MarketplaceTokens
                collectionId={collectionId}
                browseCollection={browseCollection}
              />
            </Tabs.Panel>
            <Tabs.Panel value="activity" pt="xs">
              <CollectionActivity
                collectionId={collectionId}
                chainId={chainId}
                address={address}
              />
            </Tabs.Panel>
          </Tabs>
        </Box>
      </AppShell>
    </MintContext.Provider>
  );
};

export default MarketplacePage;
